module.exports = __webpack_public_path__ + "static/img/dash-stat-courses.c6e2b1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dash-stat-courses.png
// module id = GmVl
// module chunks = 1